module.exports = __webpack_public_path__ + "static/media/neill-kumar.8f638c30.jpg";